module.exports = __webpack_public_path__ + "img/andritz.f1c71887.svg";